import React, {useEffect, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {useLocation} from 'react-router-dom'
import Select, { CSSObjectWithLabel } from 'react-select'
import {fetchData, formatNumber, toasterrormsg, BOOKABLE_CATEGORIES} from '../../../reusable'
import {getCSS, getCSSVariableValue} from '../../../_metronic/assets/ts/_utils'
import moment from 'moment'
import { Tr } from '../../../_metronic/i18n/Tr'

type Props = {
  className: string
  data: {name: string; data: number[]}[]
  categories: string[]
  totalRevenue: string
  sendData?: any
  sendData2?: any
  length?: any
}

const ChartsWidget9: React.FC<Props> = ({
  className,
  data,
  categories,
  totalRevenue,
  sendData,
  sendData2,
  length,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  let t = Tr()

  const location = useLocation()
  const [selectedCategory, setSelectedCategory] = useState('') as any
  const [selectedVendor, setSelectedVendor] = useState('') as any
  const [selectedProperty, setSelectedProperty] = useState('') as any
  const [vendorList, setVendorList] = useState([])
  const [propertyList, setPropertyList] = useState([]) as any
  const [categoryList] = useState([
    {value: '0', label: 'ALL'},
    ...BOOKABLE_CATEGORIES,
  ]) as any

  const [monthList] = useState([
    {value: 0, label: 'ALL'},
    {value: '1', label: 'January'},
    {value: '2', label: 'February'},
    {value: '3', label: 'March'},
    {value: '4', label: 'April'},
    {value: '5', label: 'May'},
    {value: '6', label: 'June'},
    {value: '7', label: 'July'},
    {value: '8', label: 'August'},
    {value: '9', label: 'September'},
    {value: '10', label: 'October'},
    {value: '11', label: 'November'},
    {value: '12', label: 'December'},
  ]) as any

  const currentYear = new Date().getFullYear()
  const yearList = Array.from({length: currentYear - 2020 + 1}, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  const [selectedYear, setSelectedYear] = useState('') as any
  const [selectedMonth, setSelectedMonth] = useState('') as any
  const [selectedVendorYear, setSelectedVendorYear] = useState(currentYear) as any
  const [selectedVendorMonth, setSelectedVendorMonth] = useState('') as any
  const getvendorlist = async (category: any) => {

    let param: any = {
      categoryId : category
    }
    
    const response: any = await fetchData('admin/vendorList', param)
    
    if (response.status == '200') {
      const data = response.data.map((item: any) => {
        return {value: item.vendorId, label: item.fullName}
      })
      data.unshift({value: 0, label: 'ALL'})
      setVendorList(data)
    } else {
      toasterrormsg(response.message)
    }
  }

  const propertyListApiCall = async (vendorId: any , categoryId:any) => {
    let param: any = {
      vendorId: vendorId,
      categoryId: categoryId,
    }
    
    var response: any = await fetchData('admin/propertylist', param)

    if (response.status == '200') {
      let data = response.data
      data.unshift({value: 0, label: 'ALL'})

      
      if(selectedCategory == 0 || vendorId == 0){
        setPropertyList([{value: 0, label: 'ALL'}])
      }else {
        setPropertyList(data)
      }
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, data, categories])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data, categories))
    if (chart) {
      chart.render()
    }

    return chart
  }

  var currentLocation = location.pathname

  const formatDate = (date: any) => {
    return moment(date).format('DD-MM-YYYY')
  }



  function getMonthStartAndEndDates(year: number, month: number) {
    if (!year) {
      return {
        startDate: '',
        endDate: '',
      }
    }
    
    let startDate, endDate

    if (month == 0) {
      
      // If month is 0, return the full year's start and end dates
      startDate = new Date(year, 0, 1) // January 1st
      endDate = new Date(year, 11, 31) // December 31st
    } else {
      startDate = new Date(year, month - 1, 1) // Start of the selected month
      endDate = new Date(year, month, 0) // Last day of the selected month
    }

    // Format dates in 'YYYY-MM-DD'
    const formattedStartDate = `${startDate.getFullYear()}-${String(
      startDate.getMonth() + 1
    ).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`
    const formattedEndDate = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(endDate.getDate()).padStart(2, '0')}`

    return {
      startDate: formatDate(formattedStartDate),
      endDate: formatDate(formattedEndDate),
    }

    
  }
  const {startDate, endDate} = getMonthStartAndEndDates(selectedVendorYear, selectedVendorMonth)

 
  return (
    <>
      {location.pathname === '/viewvendorwiseearning/' ? (
        <div className='d-flex flex-wrap justify-content-center gap-4'>
          <Select
            name='selectVendorYear'
            id='selectVendorYear'
            placeholder={t('Select Year')}
            isSearchable={true}
            options={yearList}
            value={yearList.find((option: any) => option.value == selectedVendorYear) || null}
            onChange={(e: any) => {
              setSelectedVendorYear(e.value)
            }}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base:CSSObjectWithLabel) => ({...base, zIndex: 9999}), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({...base, zIndex: 9999}),
            }}
          />
          <Select
            name='selectVendorMonth'
            id='selectVendorMonth'
            placeholder={t('Select Month')}
            isSearchable={true}
            options={monthList}
            value={monthList.find((option: any) => option.value === selectedVendorMonth) || null}
            onChange={(e: any) => {
              setSelectedVendorMonth(e.value)
            }}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base : CSSObjectWithLabel) => ({...base, zIndex: 9999}), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({...base, zIndex: 9999}),
            }}
          />
          <Select
            name='selectCategory'
            id='selectCategory'
            placeholder={t('Select Category')}
            isSearchable={true}
            options={categoryList}
            value={categoryList.find((option: any) => option.value === selectedCategory) || null}
            onChange={(e: any) => {
              setSelectedCategory(e.value)
              setSelectedProperty("")
              setSelectedVendor("")
              setPropertyList([])
              setVendorList([])
              getvendorlist(e.value)
            }}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base:CSSObjectWithLabel) => ({...base, zIndex: 9999}), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({...base, zIndex: 9999}),
            }}
          />

          <Select
            name='selectVendor'
            id='selectVendor'
            placeholder={t('Select Vendor')}
            isSearchable={true}
            options={vendorList}
            value={vendorList.find((option: any) => option.value === selectedVendor?.value) || null}
            onChange={(e: any) => {
              setSelectedVendor(e)
              propertyListApiCall(e.value , selectedCategory)
            }}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base:CSSObjectWithLabel) => ({...base, zIndex: 9999}), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({...base, zIndex: 9999}),
            }}
          />

          <Select
            name='selectProperty'
            id='selectProperty'
            placeholder={t('Select Property')}
            isSearchable={true}
            options={propertyList}
            value={
              propertyList.find((option: any) => option.value === selectedProperty?.value) || null
            }
            onChange={(e: any) => setSelectedProperty(e)}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base:CSSObjectWithLabel) => ({...base, zIndex: 9999}), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({...base, zIndex: 9999}),
            }}
          />

          <button
            className='btn btn-success'
            onClick={() =>
              sendData
                ? sendData({
                    vendorName: selectedVendor.label,
                    propertyName: selectedProperty.label,
                    vendorId: selectedVendor.value,
                    categoryId: selectedCategory,
                    startDate: startDate,
                    endDate: endDate,
                    propertyId: selectedProperty.value,
                    selectedVendorYear: selectedVendorYear,
                    selectedVendorMonth: selectedVendorMonth,
                  })
                : ''
            }
          >
            {t("Apply")}
          </button>

          <button
            className='btn btn-danger'
            onClick={() => {
              setSelectedCategory('')
              setSelectedVendor('')
              setVendorList([])
              setSelectedVendorMonth('')
              setSelectedVendorYear('')
              setSelectedProperty('')
              setPropertyList([])
              sendData &&
                sendData(null)
            }}
          >
            {t("Clear")}
          </button>
        </div>
      ) : (
        ''
      )}

      {location.pathname === '/viewcategorywiseearningbyyearmonth' ? (
        <div className='d-flex flex-wrap gap-4'>
          <Select
            name='selectYear'
            id='selectYear'
            placeholder={t('Select Year')}
            isSearchable={true}
            options={yearList}
            value={yearList.find((option: any) => option.value === selectedYear?.value) || null}
            onChange={(e: any) => {
              setSelectedYear(e)
            }}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base:CSSObjectWithLabel) => ({...base, zIndex: 9999}), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({...base, zIndex: 9999}),
            }}
          />

          <Select
            name='selectMonth'
            id='selectMonth'
            placeholder={t('Select Month')}
            isSearchable={true}
            options={monthList}
            value={monthList.find((option: any) => option.value === selectedMonth?.value) || null}
            onChange={(e: any) => setSelectedMonth(e)}
            menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
            styles={{
              menuPortal: (base:CSSObjectWithLabel) => ({...base, zIndex: 9999}), // Highest z-index
              menu: (base :CSSObjectWithLabel) => ({...base, zIndex: 9999}),
            }}
          />

          <button
            className='btn btn-success'
            onClick={() =>
              sendData2
                ? sendData2({
                    year: selectedYear.value,
                    monthId: selectedMonth.value,
                  })
                : ''
            }
          >
            {t("Apply")}
          </button>

          <button
            className='btn btn-danger'
            onClick={() => {
              setSelectedYear('')
              setSelectedMonth('')
              sendData2 &&
                sendData2({
                  year: '',
                  monthId: '',
                })
            }}
          >
            {t("Clear")}
          </button>
        </div>
      ) : (
        ''
      )}

      <div className={`card ${className} position-relative`}>
        <img
          src={toAbsoluteUrl('/media/otherSVG/Group148.svg')}
          className='position-absolute top-0 end-0'
          style={{zIndex: 0}}
        />

        <div className='card-header border-0 pt-5' style={{zIndex: 1}}>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1 d-flex align-items-center'>
              {/* <FontAwesomeIcon icon={faCircleCheck} className='fontsize35px me-3 themeGreenColor' /> */}
              <img alt='images' src={toAbsoluteUrl('/media/otherSVG/Dollar.svg')} />
              <span className='fs-3 fw-bold'>
                {' '}
                {currentLocation == '/viewvendorwiseearning/'
                  ? t('Total Vendor Earnings')
                  : t('Total Revenue')}{' '}
              </span>
            </span>
          </h3>

          <label className='fontsize48px fontweight700 w-100 themeBlueColor'>
            {length == '0' ? '0' : formatNumber(parseFloat(totalRevenue))}
          </label>
        </div>

        {length != '0' ? (
          <div className='card-body '>
            <div
              ref={chartRef}
              id='kt_charts_widget_1_chart'
              className='mt-10'
              style={{height: '350px'}}
            />
          </div>
        ) : (
          <div className='d-flex justify-content-center align-items-center'>
            <h1 className='mt-10'>
              {' '}
              {currentLocation == '/dashboard'
                ? ''
                : currentLocation == '/viewcategorywiseearningbyyearmonth'
                ? selectedYear == '' && selectedMonth == ''
                  ? 'No Data Available'
                  : 'There Is No Data In the Selected Year and Month'
            
                : 'No Data Available'}{' '}
            </h1>
          </div>
        )}
      </div>
    </>
  )
}

export {ChartsWidget9}

function getChartOptions(
  height: number,
  data: {name: string; data: number[]}[],
  categories: string[]
): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue('--greencolorprofit')
  const secondaryColor = getCSSVariableValue('--greencolorrevenue')

  return {
    series: data,
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
        formatter: function (val) {
          return val.toFixed(2)
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val: any) {
          return formatNumber(parseFloat(val))
        },
      },
    },
    colors: [baseColor, secondaryColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}
